import { render, staticRenderFns } from "./GeneralInformations.vue?vue&type=template&id=19c6039b&"
import script from "./GeneralInformations.vue?vue&type=script&lang=ts&"
export * from "./GeneralInformations.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralInformations.vue?vue&type=style&index=0&id=19c6039b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports